import { jsx as _jsx } from "react/jsx-runtime";
import { AlertDot } from '#pplx/frontend/aether/components/AlertDot/index.js';
import classNames from 'classnames';
export const ButtonBadge = ({ visible, variant = 'sidebar', displayCount, 'data-testid': dataTestId, }) => {
    if (variant === 'topbar') {
        if (!visible) {
            return null;
        }
        return (_jsx("div", { "aria-hidden": true, className: "pointer-events-none absolute -right-two -top-two grid size-4 place-items-center rounded-full bg-super-strong text-center text-3xs leading-none text-inverse", children: displayCount }));
    }
    return (_jsx("div", { "data-testid": visible ? dataTestId : undefined, className: classNames('pointer-events-none absolute rounded-full inline-flex', {
            'right-1.5 top-2.5': variant === 'accessory',
            'top-two right-0 bg-base': variant === 'sidebar',
            'opacity-0': !visible,
        }), children: _jsx(AlertDot, { size: "sm", ringColor: "subtle" }) }));
};
//# sourceMappingURL=ButtonBadge.js.map